/* globals dataLayer, adobe */
(function (window, angular, undefined) {
angular.module("formApp").controller("stepThreeCtrl", [
"$scope",
"$rootScope",
"$q",
"FormService",
"$state",
"$stateParams",
"$log",
"formData",
"scrollToPoint",
"$timeout",
"sessionService",
"errorHandler",
"LoadingInterceptor",
"updateHeader",
"$window",
"dataLayerService",
"$filter",
"$location",
function (
$scope,
$rootScope,
$q,
formService,
$state,
$stateParams,
$log,
formData,
scrollToPoint,
$timeout,
sessionService,
errorHandler,
loadingInterceptor,
updateHeader,
$window,
dataLayerService,
$filter,
$location
) {
$scope.windowWidth = $window.innerWidth;

$window.onresize = function (event) {
$timeout(function () {
$scope.windowWidth = $window.innerWidth;
});
};

$scope.petRemoved = false;
sessionService.start();
$rootScope.discounts = {};
var evt = new CustomEvent("currentStep", { detail: { step: "3" } });
window.dispatchEvent(evt);

$rootScope.$on("discountApplied", function (event, args) {
window.hasScrolled = true;
$rootScope.discounts.type = "";
$rootScope.discounts.value = "";
if (args.type === "Online") {
$rootScope.discounts.type = "Online";
$rootScope.discounts.value = args.value;
} else if (args.type === "OneMonthFree") {
$rootScope.discounts.type = "OneMonthFree";
} else if (args.type === "TwoMonthFree") {
$rootScope.discounts.type = "TwoMonthFree";
} else {
$rootScope.discounts.type = "Discount";
}
});

var mboxName = "orderStep3NewQB";

if (sessionStorage.getItem("eQuote")) {
sessionStorage.removeItem("formStateUri");
sessionStorage.removeItem("retrieveQuote");
sessionStorage.removeItem("eQuote");
}
if (sessionStorage.getItem("journey") === "combined") {
$rootScope.mainJourney = false;
$rootScope.journeyClass = "combined";
}
if (sessionStorage.getItem("journey") === "single") {
$rootScope.mainJourney = true;
$rootScope.journeyClass = "single";
}

var recognition = false;
var isEcover = sessionStorage.getItem("eCoverNote") === "true";
if (isEcover) {
mboxName = "orderStep3Ecover";
}

if ($scope.eCoverRecognition) {
recognition = true;
}

$scope.$on("recognitionCancelled", function () {
recognition = false;
dataLayerPush();
});

$scope.$watch("gaPetPostition", function (newVal, oldVal) {
if (newVal) {
dataLayerPush();
}
});

function dataLayerPush() {
dataLayer.push({
funnelName: parseInt(dataLayerService.setFunnelName()),
event: "dataAvailable",
quoteRetrieval: dataLayerService.setRetrieveMode(),
funnelVersion: "1.0",
funnelPageNumber: 3,
funnelSfc:
sessionStorage.getItem("eCoverJourney") === "recognised" ||
sessionStorage.getItem("eCoverJourney") === "return-rec",
funnelFc: sessionStorage.getItem("eCoverJourney") === "retrieveQB",
funnelFcRtn:
sessionStorage.getItem("eCoverJourney") === "return" ||
sessionStorage.getItem("eCoverJourney") === "return-rec",
petDetailsPosition: $scope.gaPetPostition,
environment: window.location.hostname,
bravCode: "",
campaignCode: dataLayerService.campaignCode(),
partnerName: dataLayerService.partnerName(),
});
}

function returnPetAge(dob) {
var a = moment();
var b = moment(dob);

var years = a.diff(b, "year");
b.add(years, "years");

var months = a.diff(b, "months");
b.add(months, "months");

var days = a.diff(b, "days");

var petAge = {
years: years,
months: months,
days: days,
};
return petAge;
}

//---GA STUFF ------
$scope.pushPet = function () {
var preQuoteVariables = [];
var i;

function returnPetBreed(type, breedOne, breedTwo) {
if (type === "MultiBreed") {
return breedOne + "," + breedTwo;
} else {
return breedOne;
}
}

for (i = 0; i < $scope.formData.pets.length; i++) {
var currentPet = {
petId: $scope.formData.pets[i].id,
policyAmount: "515.16",
policyType: "DCB",
petDetailsPosition: i,
species: $scope.formData.pets[i].type,
petType: $scope.formData.pets[i].details.type,
breed: returnPetBreed(
  $scope.formData.pets[i].details.type,
  $scope.formData.pets[i].details.breedOne,
  $scope.formData.pets[i].details.breedTwo
),
weight: "n/a",
gender: $scope.formData.pets[i].details.sex,
neutered: $scope.formData.pets[i].details.spayedOrNeutered,
petAge: returnPetAge($scope.formData.pets[i].details.dateOfBirth),
};
preQuoteVariables.push(currentPet);
}

var pc = $scope.formData.aboutYou.postCode;
var quoteVariables = dataLayerService.getQuoteVar();
$rootScope.gaquoteVariables = dataLayerService.getQuoteVar();
dataLayer.push({
event: "quoteDataAvailable",
funnelName: parseInt(dataLayerService.setFunnelName()),
funnelVersion: "1.0",
funnelPageNumber: 3,
environment: window.location.hostname,
bravCode: "",
campaignCode: dataLayerService.campaignCode(),
partnerName: dataLayerService.partnerName(),
postcode: pc.split(" ", 1).toString(),
quoteId: $window.sessionStorage.getItem("formStateUri"),
quoteVariables: quoteVariables,
quoteRetrieval: dataLayerService.setRetrieveMode(),
numberOfPets: $scope.formData.pets.length,
multipetFlag: dataLayerService.multiPetTest(
$scope.formData.pets.length
),
});

dataLayer.push({
event: "addToCart",
postcode: pc.split(" ", 1).toString(),
quoteId: $window.sessionStorage.getItem("formStateUri"),
policyVariables: dataLayerService.getQuoteVar(),
});
};


//---GA STUFF ------

var products;

$scope.currentPetInView = parseInt($stateParams.id, 10) || 0;
$scope.formData = formData;
$scope.parseInt = parseFloat;
$scope.productsLoaded = false;
$scope.showCoverOptions = false;
$scope.showUpgrade = false;
$scope.showSummary = false;
$scope.gotoProduct = gotoProduct;
$scope.changingCover = false;
$scope.rabbitPlanOnly = false;
$scope.removeAllCovers = false;

if (isEcover) {
sessionStorage.setItem("currentRefreshState", "quote-ec");
} else {
sessionStorage.setItem("currentRefreshState", "step-3");
$scope.isPAH =
$scope.pah || $scope.pahvip || $scope.pahvipa || $scope.pahvipb;
}

$scope.$watch("gatewayReady", function (newVal, oldVal) {
if (newVal === true) {
if (sessionStorage.getItem("formStateUri")) {
formService.setApplicationId(
  sessionStorage.getItem("formStateUri")
);
}
sessionService.heartbeat();
// console.log('updated data', $scope.formData.pet);
getIfsData();
}
});

$scope.$on("updateSummary", function () {
// if a pet has been deleted
if ($scope.formData.pets.length <= $scope.currentPetInView) {
$scope.currentPetInView = $scope.formData.pets.length - 1;
}
// multi-pet scenarios
if (
$scope.formData.pets.length > 1 && !hasCover(formData.pets[$scope.currentPetInView])) {
// update header image
updateHeader.petType = $scope.formData.pets[$scope.currentPetInView].type;
// check if older pet or a rabbit to pre select plan as only one available
checkIsOldPet();
checkIsRabbitPlan();
checkAllPetsCovered();
$scope.currentPetInView = firstPetWithoutCover();
$state.go(isEcover ? "quote-ec-select" : "step-3-select", {
id: $scope.currentPetInView,
selectState: "quote",
});
} 
else if (
$scope.formData.pets.length > 1 && hasCover(formData.pets[$scope.currentPetInView])) {
// update header image
updateHeader.petType = $scope.formData.pets[$scope.currentPetInView].type;
// check if older pet or a rabbit to pre select plan as only one available
checkIsOldPet();
checkIsRabbitPlan();
checkAllPetsCovered();
$scope.currentPetInView = firstPetWithoutCover();
$state.go(isEcover ? "quote-ec-select" : "step-3-select", {
id: $scope.currentPetInView,
selectState: "quote",
});
}
// single pet scenarios
else if ($scope.formData.pets.length === 1) {
checkAllPetsCovered();
if (!hasCover(formData.pets[$scope.currentPetInView])) {
$state.go(isEcover ? "quote-ec-select" : "step-3-select", {
  id: $scope.currentPetInView,
  selectState: "quote",
});
} else {
$state.go(isEcover ? "quote-ec-select" : "step-3-select", {
  id: $scope.currentPetInView,
  selectState: "quote",
});
}
}
});

function hasCover(pet) {
return (
pet &&
pet.chosenCover &&
pet.chosenCover.productId &&
pet.chosenCover.productLine
);
}

function firstPetWithoutCover() {
var i = 0;
while (
i < $scope.formData.pets.length - 1 &&
$scope.formData.pets[i].chosenCover &&
$scope.formData.pets[i].chosenCover.productId &&
$scope.formData.pets[i].chosenCover.productLine
) {
i++;
}
return i;
}

$scope.setProductUpgrade = function (pet) {
if (
pet.chosenCover.upgrades &&
pet.chosenCover.deathCover === "deathCoverNo"
) {
delete pet.chosenCover.upgrades; // remove property so we don't send junk to IFS
}

if (pet.chosenCover.deathCover === "deathCoverYes") {
pet.chosenCover.upgrades = "DBN";
}
loadingInterceptor.incrementRequests("Updating");
formService
.postChosenCover(pet)
.then(function success() {
// get application and set product prices per pet
return formService.getRunningTotals();
})
.then(
function (response) {
  $scope.formData.runningTotals = response.data;
  loadingInterceptor.decrementRequests();
},
function failure(e) {
  errorHandler.reportErrors(e, "redirect", "tech");
}
);
};

$scope.nextPet = function () {
$timeout(function () {
$scope.gaPetPostition = $scope.gaPetPostition + 1;
});

$scope.currentPetInView = parseInt($scope.currentPetInView, 10) + 1;
var petType = $scope.formData.pets[0].type;
if (sessionStorage.getItem("petBreed") && petType === "dog") {
var adBreed = sessionStorage.getItem("petBreed");
updateHeader.petType = adBreed;
} else {
updateHeader.petType =
$scope.formData.pets[$scope.currentPetInView].type;
}

// Reset the view selection
$scope.showCoverOptions =
$scope.showUpgrade =
$scope.showSummary =
false;
$state.go(isEcover ? "quote-ec-select" : "step-3-select", {
id: $scope.currentPetInView,
selectState: "quote",
});
scrollToPoint.scrollTo("topOfTheApp", 20, "id");
};

$scope.reviewCover = function (index) {
if (index === $scope.currentPetInView) {
window.hasScrolled = true;
$scope.currentPetInView = index;
var petType = $scope.formData.pets[0].type;
if (sessionStorage.getItem("petBreed") && petType === "dog") {
var adBreed = sessionStorage.getItem("petBreed");
updateHeader.petType = adBreed;
} else {
updateHeader.petType =
  $scope.formData.pets[$scope.currentPetInView].type;
}
$scope.showCoverOptions = $scope.showSummary = true;
$scope.showUpgrade = upgradeIsAvailable(
formData.pets[$scope.currentPetInView]
);
$timeout(
function () {
  gotoProduct(
    $scope.formData.pets[$scope.currentPetInView].chosenCover
      .productLine,
    20,
    "id"
  );
},
300,
false
);
} else {
$state.go(isEcover ? "quote-ec-select" : "step-3-select", {
id: index,
selectState: "quote",
});
}
};

function upgradeIsAvailable(pet) {
var product = products.filter(function (prod) {
return prod.id === pet.chosenCover.productId && prod.pet === pet.uri;
});

// product is an array so check first one and then first upgrade - there's only ever one
if (
product[0] &&
product[0].upgrades &&
product[0].upgrades.length &&
!product[0].upgrades[0].unavailable
) {
return true;
} else {
return false;
}
}

function convertCovers(obj) {
var returnObj = {};
obj.forEach(function (item) {
if (item.sectionLimit && item.sectionLimit !== "0") {
returnObj[item.sectionId] = {
  sectionLimit: $filter("currency")(item.sectionLimit, "£", 0),
  amount: item.sectionOptional === "Y" ? "Optional cover" : $filter("currency")(item.sectionLimit, "£", 0),
  excess: $filter("currency")(item.sectionFlatXs, "£", 0) + (item.sectionPctXs !== "0" ? " + " + item.sectionPctXs + "%" : "")
};
}
});
return returnObj;
}

function trustpilotWidget() {
// console.log('fired');
// Required to fire Trustpilot widget as well as js script
var trustboxRef = document.getElementById("trustbox");
// console.log('tp', trustboxRef);
if (trustboxRef && window.Trustpilot) {
window.Trustpilot.loadFromElement(trustboxRef);
}
}

function getIfsData() {
// console.log('IFS call');

loadingInterceptor.incrementRequests();
formService
.getRunningTotals()
.then(function (response) {
// get actual product prices - need to call before getApplication so that selected cover is validated on IFS
$scope.gaPetPostition = $scope.currentPetInView + 1;
products = response.data.products;
$scope.products = products;
$scope.formData.runningTotals = response.data;
// console.log('response run totals', response.data);
return formService.getApplication();
})
.then(function (response) {
// console.log('IFS data', response.data);
var data = response.data;
$scope.quoteRef = response.data.officeUseOnly.quoteReference;
$scope.parisRef =
  response.data.officeUseOnly.params &&
  response.data.officeUseOnly.params.parisRefNo;
$scope.formData.pets = data.application.pets;
$scope.formData.aboutYou = data.application.aboutYou;
$scope.formData.cover = data.application.cover;

if (
  response.data.officeUseOnly.params &&
  response.data.officeUseOnly.params.coverNoteEndDate
) {
  $scope.freeCoverExpired =
    moment(
      response.data.officeUseOnly.params.coverNoteEndDate,
      "DD/MM/YYYY"
    )
      .startOf("day")
      .diff(moment().startOf("day"), "days") < 0;
  $scope.coverNoteEndDate = moment(
    response.data.officeUseOnly.params.coverNoteEndDate,
    "DD/MM/YYYY"
  ).toDate();
}
})
.then(function (response) {
$scope.productsLoaded = true;
if (
  sessionStorage.getItem("retrieveQuote") === "true" &&
  sessionStorage.getItem("reQuoteModal") === "true"
) {
  $scope.triggermbmodal = true;
  scrollToPoint.scrollTo("topOfTheApp", 20, "id");
}

// TODO - also used in summary directive - refactor into common util
$scope.formData.pets.forEach(function (pet) {
  pet.cc = {};
  pet.cc.hasC4l = true;
  angular.forEach(products, function (value, key) {
    if (pet.uri === value.pet) {
      // console.log('ifs pet details', pet);
      //     console.log('ifs pet', pet.uri, value.pet);
      if (value.covers) {
        // console.log('ifs covers', value.covers);
        value.formattedCovers = convertCovers(value.covers);
      }
      if (value.id === "DVA" || value.id === "CVA") {
        // console.log('ifs essential', value.id);
        pet.cc.essential = value;
      }
      if (
        value.id === "DCA" ||
        value.id === "CCA" ||
        value.id === "RCA"
      ) {
        // console.log('ifs classic', value.id);
        pet.cc.classic = value;
        if (value.unavailable) {
          pet.cc.hasC4l = false;
        }
      }
      if (value.id === "DCB" || value.id === "CCB") {
        // console.log('ifs classicPlus', value.id);
        pet.cc.classicPlus = value;
        if (value.unavailable) {
          pet.cc.hasC4l = false;
        }
      }
      if (value.id === "DCC" || value.id === "CCC") {
        // console.log('ifs ultimate', value.id);
        pet.cc.ultimate = value;
        if (value.unavailable) {
          pet.cc.hasC4l = false;
        }
      }
    }
  });
});

var scrollToPosition;

if (!$stateParams.selectState) {
  for (var i = 0, len = $scope.formData.pets.length; i < len; i++) {
    var pet = $scope.formData.pets[i];

    if (pet.chosenCover) {
      $scope.currentPetInView = i;
      if (pet.chosenCover.productLine) {
        scrollToPosition = "quote";
      }
      if (pet.chosenCover.productId) {
        scrollToPosition = "products";
      }
    } else {
      break;
    }
  }
  if (
    $scope.currentPetInView === 0 &&
    !$scope.formData.pets[0].chosenCover
  ) {
    $state.go(
      isEcover ? "quote-ec-select" : "step-3-select",
      { id: $scope.currentPetInView, selectState: "quote" },
      { location: "replace" }
    );
  } else {
    $state.go(
      isEcover ? "quote-ec-select" : "step-3-select",
      {
        id: $scope.currentPetInView,
        selectState: scrollToPosition,
      },
      { location: "replace" }
    );
  }
}

if (!$scope.formData.pets[$stateParams.id]) {
  $scope.petRemoved = true;
  updateHeader.petType = "dog";
  return false;
}

if ($stateParams.selectState === "quote") {
  $scope.showSummary = false;
  $scope.showCoverOptions = false;
  $scope.showUpgrade = false;
}

if (
  $stateParams.selectState === "quote" &&
  $scope.formData.pets[$stateParams.id].chosenCover
) {
  if ($scope.formData.pets[$stateParams.id].chosenCover.productId) {
    $scope.showCoverOptions = true;
    $scope.showSummary = true;

    if (
      sessionStorage.getItem("retrieveQuote") === "true" &&
      sessionStorage.getItem("reQuoteModal") === "true"
    ) {
      $scope.triggermbmodal = true;
      scrollToPoint.scrollTo("topOfTheApp", 20, "id");
    } else {
      if (
        $scope.formData.pets[$stateParams.id].chosenCover
          .productLine === "C4L"
      ) {
        scrollToPosition = "summary";
      } else {
        scrollToPosition = "quote";
      }
    }

    if (upgradeIsAvailable($scope.formData.pets[$stateParams.id])) {
      $scope.showUpgrade = true;
    }
  } else if (
    $scope.formData.pets[$stateParams.id].chosenCover.productLine
  ) {
    $scope.showCoverOptions = true;
    scrollToPosition = "quote";
    $scope.gotoProduct(
      $scope.formData.pets[$stateParams.id].chosenCover.productLine,
      20,
      "id"
    );
  } else {
    $state.go(
      isEcover ? "quote-ec-select" : "step-3-select",
      { id: firstPetWithoutCover(), selectState: "quote" },
      { location: "replace" }
    );
  }
}

var petType = $scope.formData.pets[0].type;
if (sessionStorage.getItem("petBreed") && petType === "dog") {
  var adBreed = sessionStorage.getItem("petBreed");
  updateHeader.petType = adBreed;
} else {
  updateHeader.petType =
    $scope.formData.pets[$scope.currentPetInView].type;
}

checkAllPetsCovered();

if (scrollToPosition === "summary") {
  $timeout(
    function () {
      gotoProduct("coverSummary", 20, "id");
    },
    300,
    false
  );
}
// console.log("scope.formData",$scope.formData);

// SESSIONCAM
if (window.sessionCamRecorder) {
  if (window.sessionCamRecorder.createVirtualPageLoad) {
    window.sessionCamRecorder.createVirtualPageLoad("stepThree");
  }
}

// need to delay to find id of Trustpilot
$timeout(function () {
  trustpilotWidget();
});

checkIsOldPet();
checkIsRabbitPlan();
})
.then(function () {
$timeout(
  function () {
    loadStickyScript();
  },
  300,
  false
);
loadingInterceptor.decrementRequests();
})
.catch(function error(error) {
errorHandler.reportErrors(error, "redirect", "tech");
});
}

function loadStickyScript() {
var scriptElement = window.document.createElement("script");
scriptElement.id = "stickyScript";
scriptElement.src =
"/etc/designs/small-animal/js/vendor/assets/price-sticky.js";
window.document.body.appendChild(scriptElement);
}

function checkIsOldPet() {
console.log('check is older pet', $scope.currentPetInView);
// Auto select: isOldPet
if (
$scope.formData.pets[$scope.currentPetInView].type !== "rabbit" &&
$scope.formData.pets[$scope.currentPetInView].cc.hasC4l === false &&
!hasCover(formData.pets[$scope.currentPetInView])
) {
// console.log('older pet setting productLine from clear');
$scope.setProductLine(
$scope.formData.pets[$scope.currentPetInView],
"Essential"
);
}
}

function checkIsRabbitPlan() {
// console.log('check is rabbit', $scope.currentPetInView);
// Auto select RABBIT PLAN if rabbit
var currentPetInView = $scope.formData.pets[$scope.currentPetInView];
if (currentPetInView.type === "rabbit") {
$scope.rabbitPlanOnly = true;
if (!hasCover(formData.pets[$scope.currentPetInView])) {
// console.log('rabbit setting productLine from clear');
$scope.setProductLine(currentPetInView, "Rabbit");
}
} else {
$scope.rabbitPlanOnly = false;
}
}

$scope.gotoSummary = function () {
$scope.showSummary = true;
$scope.gotoProduct("coverSummary", 20, "id");
loadingInterceptor.incrementRequests("Updating");
formService.getRunningTotals().then(
function (response) {
$scope.formData.runningTotals = response.data;
loadingInterceptor.decrementRequests();
},
function failure(e) {
errorHandler.reportErrors(e, "redirect", "tech");
}
);
};

$scope.setProductId = function (pet, productId) {
pet.chosenCover = pet.chosenCover || {};
pet.chosenCover.productId = productId;
// fix issue with running totals
if(!pet.chosenCover.deathCover) {
// console.log('fired', pet.chosenCover.deathCover);
pet.chosenCover.deathCover = undefined;
}

var product = products.filter(function (prod) {
return prod.id === pet.chosenCover.productId && prod.pet === pet.uri;
});

// product is an array so check first one and then first upgrade - there's only ever one
if (
product[0].upgrades &&
product[0].upgrades.length &&
!product[0].upgrades[0].unavailable
) {
$scope.showUpgrade = true;
$scope.showSummary = true;
} else {
$scope.showUpgrade = false;
$scope.showSummary = true;
if (
pet.chosenCover.productLine !== "Essential" &&
pet.chosenCover.productLine !== "Rabbit"
) {
$scope.gotoProduct("coverSummary", 20, "id");
}
}

loadingInterceptor.incrementRequests("Updating");
formService
.postChosenCover(pet)
.then(function success() {
// console.log('post productId first call', pet);
// get application and set product prices per pet
return formService.getRunningTotals();
})
.then(
function (response) {
  // console.log('post productId second call', response);
  $scope.formData.runningTotals = response.data;
  checkAllPetsCovered();
  loadingInterceptor.decrementRequests();
},
function failure(e) {
  errorHandler.reportErrors(e, "redirect", "tech");
}
);
};

$scope.setProductLine = function (pet, productLine) {
pet.chosenCover = pet.chosenCover || {};
pet.chosenCover.productLine = productLine;
pet.chosenCover.productId = undefined;
delete pet.chosenCover.upgrades;
pet.chosenCover.deathCover = undefined;
loadingInterceptor.incrementRequests("Updating");

formService.postChosenCover(pet, $scope.insuranceApplicationUri).then(
function success(data) {
  // console.log('set productLine', pet, $scope.insuranceApplicationUri);

// great, nothing to do
loadingInterceptor.decrementRequests();
// need to delay to find id of Trustpilot
$timeout(function () {
  trustpilotWidget();
});
var evt = new CustomEvent("currentStep", {
  detail: { step: "3.1" },
});
window.dispatchEvent(evt);
$state.go(isEcover ? "quote-ec-select" : "step-3-select", {
  id: $scope.currentPetInView,
  selectState: "quote",
});
},
function failure(e) {
errorHandler.reportErrors(e, "redirect", "tech");
}
);
//remove sticky on selecting the cover
var sticky = document.querySelector('.hideSticky');
if (sticky) {
sticky.classList.remove('hideSticky');
}
};

$scope.clearAllProducts = function () {
for (var i = 0, len = $scope.formData.pets.length; i < len; i++) {
var pet = $scope.formData.pets[i];
pet.chosenCover = pet.chosenCover || {};
pet.chosenCover.productId = undefined;
delete pet.chosenCover.upgrades;
pet.chosenCover.productLine = undefined;
pet.chosenCover.deathCover = undefined;
}

loadingInterceptor.incrementRequests("Updating");
formService.clearAllProduct().then(
function success(data) {
  // console.log('post clear all products', data);
  loadingInterceptor.decrementRequests();
  $state.go(isEcover ? "quote-ec-select" : "step-3-select", {
    id: 0,
    selectState: "quote",
  }).then(function () {
    //Once clearing all product check if older pet or rabbit to show relevant cover plan in UI
    if (!hasCover(formData.pets[$scope.currentPetInView])) {
      if ($scope.formData.pets[$scope.currentPetInView].type !== "rabbit" &&
        $scope.formData.pets[$scope.currentPetInView].cc.hasC4l === false) {
        $scope.productsLoaded = true;
      }
      $scope.rabbitPlanOnly = formData.pets[$scope.currentPetInView].type === "rabbit" ? true : false;
    }
  });
  $scope.gotoProduct('skipnav', 20, "id");
},
function failure(e) {
  errorHandler.reportErrors(e, "redirect", "tech");
}
);
};

$scope.clearProduct = function (pet) {
// console.log('clearProduct');

pet.chosenCover = pet.chosenCover || {};
pet.chosenCover.productLine = undefined;
pet.chosenCover.productId = undefined;
delete pet.chosenCover.upgrades;
pet.chosenCover.deathCover = undefined;

loadingInterceptor.incrementRequests("Updating");

formService.postChosenCover(pet, $scope.insuranceApplicationUri).then(
function success(data) {
// console.log('post clear product', data);
// need to delay to find id of Trustpilot
$timeout(function () {
  trustpilotWidget();
});
$state.go(isEcover ? "quote-ec-select" : "step-3-select", {
  id: firstPetWithoutCover(),
  selectState: "quote",
});
$scope.gotoProduct(
  'skipnav',
  20,
  "id"
);
}
).then(
function () {
// console.log('post clear product second call');
// Once clearing product check if older pet or rabbit to show relevant cover plan in UI
checkIsOldPet();
checkIsRabbitPlan();
loadingInterceptor.decrementRequests();
},
function failure(e) {
errorHandler.reportErrors(e, "redirect", "tech");
}
);
};

$scope.saveQuote = function () {
$scope.quoteSaved = false;
formService
.saveQuote()
.then(function success() {
var pc = $scope.formData.aboutYou.postCode;
//Fire GA Event
dataLayer.push({
  event: "saveQuoteData",
  funnelName: $rootScope.campaignFunnel,
  funnelVersion: "1.0",
  funnelPageNumber: 3,
  environment: window.location.hostname,
  bravCode: "",
  campaignCode: "",
  partnerName: dataLayerService.partnerName(),
  postcode: pc.split(" ", 1).toString(),
  quoteId: $window.sessionStorage.getItem("formStateUri"),
  quoteVariables: dataLayerService.getQuoteVar(),
  quoteRetrieval: dataLayerService.setRetrieveMode(),
  numberOfPets: $scope.formData.pets.length,
  multipetFlag: dataLayerService.multiPetTest(),
});
$scope.quoteSaved = true;
})
.catch(function error(error) {
$scope.quoteSaved = true; // quote is saved in IFS anyway... TODO - notify user of failue
errorHandler.reportErrors(error, "redirect", "tech");
});
};

$scope.submit = function (e) {
submitQuote();
};

function submitQuote() {
loadingInterceptor.incrementRequests();
var petIndex = 0;
processForm(petIndex);
}

function processForm(index) {
if (index === $scope.formData.pets.length) {
loadingInterceptor.decrementRequests();
if (isEcover) {
$state.go("questions-ec", { forward: true });
} else {
$state.go("step-4", { forward: true });
}
} else {
var pet = $scope.formData.pets[index];
formService.postChosenCover(pet, $scope.insuranceApplicationUri).then(
function success(response, status) {
  if (response.data && response.data.uri) {
    processForm(index + 1);
  }
},
function failure(e) {
  errorHandler.reportErrors(e, "redirect", "tech");
}
);
}
}

/*setApplicationState - Deprecated - now handled in getIfsData */
function setApplicationState(ppID) {
var petId;

if (ppID) {
petId = parseInt(ppID, 10);
} else {
petId = parseInt($stateParams.petId, 10);
}

$scope.currentPetInView = petId;
updateHeader.petType = formData.pets[petId].type;

if ($stateParams.position === "quote") {
$scope.showCoverOptions = true;
$timeout(
function () {
  gotoProduct(
    formData.pets[petId].chosenCover.productLine,
    20,
    "id"
  );
},
300,
false
);
}

if ($stateParams.position === "summary") {
$scope.showCoverOptions = true;

var product = products.filter(function (prod) {
return (
  prod.id === formData.pets[petId].chosenCover.productId &&
  prod.pet === formData.pets[petId].uri
);
});
if (
product[0].upgrades &&
product[0].upgrades.length &&
!product[0].upgrades[0].unavailable
) {
$scope.showUpgrade = true;
}
$scope.showSummary = true;
$timeout(
function () {
  gotoProduct("coverSummary", 20, "id");
},
300,
false
);
}
checkAllPetsCovered();
}

function checkAllPetsCovered() {
// console.log('check pets all covered');
$scope.allPetsHaveCover = true;
formData.pets.forEach(function (value, key) {
if (
!value.chosenCover ||
(value.chosenCover && !value.chosenCover.productId)
) {
$scope.allPetsHaveCover = false;
}
});
}

function gotoProduct(product, speed, type) {
$timeout(
function () {
// console.log('scroll', product, speed, type);
scrollToPoint.scrollTo(product, speed, type);
},
0,
false
);
}

$scope.changeCover = function () {
$scope.changingCover = true;
$timeout(
function () {
gotoProduct("changingCover", 20, "id");
},
300,
false
);
};

$scope.changeCoverTo = function (pet, productLine) {
$scope.changingCover = false;
if (pet.chosenCover.productLine !== productLine) {
$scope.setProductLine(pet, productLine);
} else {
$timeout(
function () {
  gotoProduct("coverSummary", 20, "id");
},
300,
false
);
}
};

$scope.cancelChangeCover = function () {
$scope.changingCover = false;
// TODO focus on correct element
$timeout(
function () {
gotoProduct("coverSummary", 20, "id");
},
300,
false
);
};

$scope.getVetFees = function (pet) {
var productId = pet.chosenCover.productId;
if (productId === "DVA" || productId === "CVA") {
return pet.cc.essential.formattedCovers.VFB.amount;
}
if (productId === "DCA" || productId === "CCA" || productId === "RCA") {
return pet.cc.classic.formattedCovers.VFB.amount;
}
if (productId === "DCB" || productId === "CCB") {
return pet.cc.classicPlus.formattedCovers.VFB.amount;
}
if (productId === "DCC" || productId === "CCC") {
return pet.cc.ultimate.formattedCovers.VFB.amount;
}
};

$scope.checkSelectBreed = function (pet, plan) {
    // check if a select breed only applies to a dog
// single pet
if(formData.pets.length === 1) {
  // check productLine selected
  if(plan === 'C4L') {
    // check if select breed is true (boolean)
    return $scope.products[0].selectBreed;
  } else if (plan === 'Essential') {
    // check if select breed is true (boolean)
    return $scope.products[3].selectBreed;
  }
}
// multi pet
if(formData.pets.length > 1) {
  var selectBreed;
  var prod = products.filter(function (prod) {
    // check productLine match with product id
    if (plan === 'C4L' && prod.id === "DCA") {
      selectBreed = prod.selectBreed;
    }
    // check productLine match with product id
    if (plan === 'Essential' && prod.id === "DVA") {
      selectBreed = prod.selectBreed;
    }
    // check product pet and pet uri match
    return prod.pet === pet.uri && prod.selectBreed === selectBreed;
  });
  // return whether select breed
  return prod[0].selectBreed;
}
};

$scope.getDeathBenefit = function (products, pet) {
// single pet
if(formData.pets.length === 1 && products[0].upgrades[0]) {
  // as upgrade amount the same for species can use this data
  // if amount changes in future to species and productId needs revising
  var deathBenefit = $scope.products[0].upgrades[0].monthlyPremium;
  // console.log('products', deathBenefit);
  return deathBenefit;
}
// multi-pet
if(formData.pets.length > 1 && products && pet) {
  var petType;
  var prod = products.filter(function (prod) {
    // if amount changes in future to species and productId needs revising
    // filter product data dependent on pet species and product ID
    if (pet.type === "dog" && (prod.id === "DVA" || prod.id === "DCA")) {
      petType = 'DCA';
    }
    if (pet.type === "cat" && (prod.id === "CVA" || prod.id === "CCA")) {
      petType = 'CCA';
    }
    if (pet.type === "rabbit" && prod.id === "RCA") {
      petType = 'RCA';
    }
    // check product pet and pet uri match && product id and petType match
    return prod.pet === pet.uri && prod.id === petType;
  });
  // return the death benefit monthly premium
  return prod[0].upgrades[0].monthlyPremium;
}
};

$scope.getTotalMonthlyPriceForSticky = function (pet, coverAmount) {
if (pet.chosenCover.deathCover === 'deathCoverYes') {
//converting amount to number to avoid concatination and limit the fraction to 2
return (Number(coverAmount.monthlyPremium) + Number($scope.getDeathBenefit(products, pet))).toFixed(2);
}
return coverAmount.monthlyPremium;
};

$scope.hideMultipetNotification = function () {
document.getElementById("multipetNotification").style.display = "none";
};

// focus back to original element when clicking close button within expanding tooltips
$scope.focusBtn = function(id) {
  var elm = document.getElementById(id);
  elm.focus();
};

},
]);
})(window, window.angular);

